import { render, staticRenderFns } from "./CallOutgoingButton.vue?vue&type=template&id=68084218&scoped=true&"
import script from "./CallOutgoingButton.vue?vue&type=script&lang=js&"
export * from "./CallOutgoingButton.vue?vue&type=script&lang=js&"
import style0 from "./CallOutgoingButton.vue?vue&type=style&index=0&id=68084218&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68084218",
  null
  
)

export default component.exports